import DResultsHealth from './DResultsHealth'

export default DResultsHealth
